var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "category-filter" }, [
    _c(
      "div",
      { staticClass: "select-filter" },
      [
        _c("select-dropdown-sort", {
          attrs: { items: _vm.sorters, name: "Sort by" },
          model: {
            value: _vm.selectValue,
            callback: function ($$v) {
              _vm.selectValue = $$v
            },
            expression: "selectValue",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "chevron" }, [
      _c(
        "a",
        {
          staticClass: "chevron-icon",
          class: { reversed: this.sortDirection === "DESC" },
          attrs: { href: "javascript:" },
          on: { click: _vm.changeDirection },
        },
        [
          _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                "xmlns:xlink": "http://www.w3.org/1999/xlink",
                width: "100",
                height: "100",
                viewBox: "0 0 100 100",
              },
            },
            [
              _c("g", [
                _c(
                  "g",
                  {
                    staticStyle: { fill: "#1A1A1A" },
                    attrs: {
                      transform:
                        "translate(50 50) scale(0.69 0.69) rotate(0) translate(-50 -50)",
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          fill: "#1A1A1A",
                          "xmlns:dc": "http://purl.org/dc/elements/1.1/",
                          "xmlns:cc": "http://creativecommons.org/ns#",
                          "xmlns:rdf":
                            "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
                          "xmlns:svg": "http://www.w3.org/2000/svg",
                          xmlns: "http://www.w3.org/2000/svg",
                          "xmlns:sodipodi":
                            "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
                          "xmlns:inkscape":
                            "http://www.inkscape.org/namespaces/inkscape",
                          version: "1.1",
                          x: "0px",
                          y: "0px",
                          viewBox: "0 0 100 100",
                        },
                      },
                      [
                        _c(
                          "g",
                          { attrs: { transform: "translate(0,-952.36218)" } },
                          [
                            _c("path", {
                              staticStyle: {
                                "text-indent": "0",
                                "text-transform": "none",
                                direction: "ltr",
                                "block-progression": "tb",
                                "baseline-shift": "baseline",
                                color: "#000000",
                                "enable-background": "accumulate",
                              },
                              attrs: {
                                d: "m 50.406266,1024.426 a 5.0005,5.0005 0 0 0 2.87497,-1.2188 l 39,-33.99995 a 5.0005,5.0005 0 1 0 -6.5625,-7.5313 l -35.71877,31.12495 -35.7187,-31.12495 a 5.0005,5.0005 0 1 0 -6.5624999,7.5313 l 38.9999999,33.99995 a 5.0005,5.0005 0 0 0 3.6875,1.2188 z",
                                fill: "#1A1A1A",
                                "fill-opacity": "1",
                                stroke: "none",
                                marker: "none",
                                visibility: "visible",
                                display: "inline",
                                overflow: "visible",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
              ]),
            ]
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }